import { useState } from "react";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import Container from "../../shared/Container";

import { useRouter } from "next/router";


const faq = [
  {
    id: 1,
    question: "What Is Employee Twin?",
    answer: () => (
      <>
        <p className="leading-[1.6]">
          ET is a digital team member that can join any team & is accessible to all the team members. ET will both function specific skill & also soft skills.
        </p>
      </>
    ),
  },
  {
    id: 2,
    question: "Who Can Hire An ET?",
    answer: () => (
      <div className="leading-[1.6]">
        <p>
          As of today, Employee Twins are not personal assistants. They are designed to be team workers who do a bunch of tasks for the team they get on to, and unlock
          capacity of all the other human team members to put their time into activities that help them pursue their purpose or play to their personal strengths. So, in a
          line, any team that intends to get a bunch of tasks done at a fraction of the cost & time incurred with a human resource can hire an ET.
        </p>
      </div>
    ),
  },
  {
    id: 3,
    question: "It has been a week and my team is not warming up to using the ET. What should I do?",
    answer: () => (
      <p className="leading-[1.6]">
        Look at the Employee Twin just as you would look at a newly added team member. The new member would come in with their set of skills, but would need some time to
        learn and fit in. If you are the leader of the team, you would need to facilitate situations which would require old team members to collaborate with the new
        member, sometimes teach the new member a thing or two. It is not very different for ET either - if you want ET to fit in, you should communicate to your team on
        when and how to use ET, recognize those in the team who have embraced ET or taken time to teach it and sometimes lead by example for your own personal
        deliverables. The good news is that our ET has the required intellectual capacity and learnability to make itself more and more useful as time goes on; plus HAP
        keeps adding to the skills catalogue every passing day.
      </p>
    ),
  },
  {
    id: 4,
    question: "How much time does it take for an ET to be onboarded?",
    answer: () => (
      <p className="leading-[1.6]">
        Your ET will be activated with the chosen Soft Skills within 72 hours of purchase. Based on the Functional Skills chosen, they may get activated between
        1-4 weeks of purchase.
      </p>
    ),
  },
];

const FAQ = () => {
  const [currentActive, setCurrentActive] = useState(null);
  const router = useRouter()
let auth = JSON.parse(localStorage.getItem("auth")).data;
  const Etroles=[
    "sanjay.bohra@unilever.com",
    "Shravyashree.JC@unilever.com",
    "Sachin.Jalota@unilever.com",
    "Arnik.Khillar@unilever.com",
    "ritish.verma@unilever.com",
    "dinesh.s3@unilever.com",
    "Abhishek.U@unilever.com",
    "mani.jha@unilever.com",
    "Vinoth.Bhaskar@unilever.com",
    "madhurima.jaggi@unilever.com",
    "Vidish.Verma@unilever.com",
    "Soumendra.Mishra@unilever.com",
    "Anshu.rani@unilever.com",
    "binay.kumar@unilever.com",
    "Gopikrishna.M@unilever.com",
    "Veshaly.varshney@unilever.com",
    "aakib.ansari@unilever.com",
    "Garima.Bhadauria@unilever.com",
    "Ayush.Rautela@unilever.com",
    "Subhadip.Das@unilever.com",
    "Arti.Hajnale@unilever.com"		
]

  return (
    <div className="py-16 bg-accent md:rounded-tr-[8rem]">
      <Container>
        <div className="grid md:grid-cols-2 gap-10">
          <div>
            <h2 className="text-4xl font-medium text-main">
              <span className="text-[#00D7C4]">F</span>requently <span className="text-[#00D7C4]">A</span>sked <br /> <span className="text-[#00D7C4]">Q</span>uestions
            </h2>
          {Etroles.includes(auth.email)?
          <div style={{ width: '300px', marginTop: '3rem' }} onClick={() => router.push('/createEmployeetwin')}>
              <button class="py-3 px-6 text-center inline-block min-w-full twinBots text-lg md:text-s font-medium text-dark border-2 border-main rounded-full duration-500 hover:bg-main hover:text-white cursor-pointer">
                Create Employee Twin
              </button>
            </div>
           :""
          }
          </div>

          <div>
            {faq.map(({ question, answer: Answer }, index) => (
              <div key={index}>
                <div
                  onClick={() => {
                    if (index === currentActive) {
                      return setCurrentActive(null);
                    }
                    setCurrentActive(index);
                  }}
                  className={` grid grid-cols-12 gap-3 cursor-pointer items-center ${
                    index % 2 === 0 ? "bg-main text-white" : "bg-accent text-main"
                  } py-4 px-4 capitalize `}>
                  <span className="col-span-10 font-medium leading-7">{question}</span>
                  <span className="col-span-2">{currentActive === index ? <AiOutlineMinus className="mt-1 h-5 w-5" /> : <AiOutlinePlus className="mt-1 h-5 w-5" />}</span>
                </div>

                <div className={`${currentActive === index ? "block" : "hidden"} text-sm px-4 py-4`}>
                  <div>{<Answer />}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default FAQ;
